module.exports = __webpack_public_path__ + "static/img/三维制作画面5.3a15d081.png";